import { AppDealers } from './pages/app-dealer';
import { AppHome } from './pages/app-home';
import { AppLogin } from './pages/app-login';
import { AppSettings } from './pages/app-settings';

import { MenuItem } from '../../webmodule-common/other/app-index';

import { PageNotFound } from './pages/page-not-found';
import { pages } from './page-constants';
import { tlang } from '../../webmodule-common/other/language/lang';
import { AppDeployments } from './pages/app-deployments';

type MenuItemSub = {
  name: string;
  title: string;
};

export function appConfigMenuPageItems() {
  const config = appConfig();
  const getItem = (item: MenuItemSub): MenuItem => {
    return { name: item.name, title: item.title, path: config.routes.find(x => x.name === item.name)?.path ?? '' };
  };
  return [
    getItem({
      name: pages.dealers,
      title: tlang`Tenant Access`
    }),
    getItem({
      name: pages.deployments,
      title: tlang`Deployments`
    }),
    getItem({
      name: pages.settings,
      title: tlang`Settings`
    })
  ];
}

export function appConfig() {
  return {
    routes: [
      {
        path: '/',
        name: pages.home,
        component: 'app-home',
        action: async () => {
          //return home
          return new AppHome();
        }
      },
      {
        path: '/login',
        name: pages.login,
        component: 'app-login',
        action: async () => {
          return new AppLogin();
        }
      },
      {
        path: '/dealers',
        name: pages.dealers,
        action: async () => {
          return new AppDealers();
        }
      },
      {
        path: '/deployments',
        name: pages.deployments,
        action: async () => {
          return new AppDeployments();
        }
      },
      {
        path: '/settings',
        name: pages.settings,
        action: async () => {
          return new AppSettings();
        }
      },
      {
        path: '(.*)',
        name: 'not-found',
        action: async () => {
          return new PageNotFound();
        }
      }
    ]
  };
}
